"use strict";
/*
 * Created on 30/01/2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Localisation_1 = require("../model/Localisation");

var LocalisationConverter_1 = require("./LocalisationConverter");
/**
 * Implementation of {@link LocalisationConverter}.
 *
 * @author JMr
 */


var LocalisationConverterImpl =
/*#__PURE__*/
function (_LocalisationConverte) {
  _inherits(LocalisationConverterImpl, _LocalisationConverte);

  function LocalisationConverterImpl() {
    _classCallCheck(this, LocalisationConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(LocalisationConverterImpl).apply(this, arguments));
  }

  _createClass(LocalisationConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new Localisation_1.Localisation(conversions.documentToClassId(source), source.locale, source.localisation);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        locale: source.locale,
        localisation: source.localisation
      });
      return result;
    }
  }]);

  return LocalisationConverterImpl;
}(LocalisationConverter_1.LocalisationConverter);

exports.LocalisationConverterImpl = LocalisationConverterImpl;